<template>
	<div id="wrapper">
      <!--<p><router-link to="/" class="body-2 font-weight-bold"> <span class="mr-05 icon solid fa-chevron-left primary-color"></span>zurück zur Übersicht</router-link></p>-->
      <article v-if="project" class="post" style="padding-top:5em">
        <RTDonateList class="mb-3" :project="project" :preview="true" :show_total_donations="true"/>
        <header class="major">
          <span class="date">{{project.country}}</span>
          <h1>{{project.title}}</h1>
          <p v-html="project.teaser"></p>
        </header>
        <!--<div v-if="!isSmallTouchDevice()" class="image main"><img alt="Projekt Cover" :src="project.cover" /></div>-->
        <RTProjectGallery id="project-view" class="mt-2" :images="project.pics" :cover="project.cover"/>
                <RTMap 
                v-if="project.lat && project.lng"
        :items="[project]"
        :singleMarkerMode="false"
        :initialZoom="4"/>
        <p v-if="project.video_url" >
          <iframe style="margin:auto;display:block;" :width="getMaxWidthOfPlayer()" :height="getHeightOfPlayer()"  :src="project.video_url" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </p>
        <p v-html="project.descr"></p>
        <!--<RTProjectDonation :project="project" :preview="false" :show_text="false" :show_descr="true"/>-->
        <RTdonate class="mt-3" :project="project" :show_header="true"/>

        <section v-if="project.project_urls" class="text-center">
          Weiterführende Informationen unter:
          <ul class="no-list-bullets">
            <li class="mt-1" v-for="(link,index) in project.project_urls" :key="index"><a :href="link" target="_blank">{{link}}</a> </li>
          </ul>
        </section>

      </article>
      <section v-else>Dieser Eintrag können wir leider nicht finden</section>
  </div>
</template>

<script>
import RTDonateList from '@/components/RTDonateList.vue'
import RTMap from '@/components/RTMap.vue'
import {categoryBase} from '@/mixins/categoryBase.js'
import {helper} from '@/mixins/helper.js'
import {shopBase} from '@/mixins/shopBase.js'
import {projectBase} from '@/mixins/projectBase.js'
import RTProjectGallery from '@/components/RTProjectGallery.vue'
import RTdonate from '@/components/RTdonate.vue'

export default {
  name: 'ProjectView',
  mixins:[helper,categoryBase,shopBase,projectBase],
  components: {
    RTMap,
    RTDonateList,
    RTProjectGallery,
    RTdonate
  },
  props:['id'],
  data: function() {
    return {
      project:null
    };
  },
  watch:{
    isLoadingProjects(v){
      if(!v && this.project==null){
        this.iniProject();
      }
    }
  },
  computed:{
  },
  methods:{

    iniProject(){
      this.project=this.getProjectById(this.id);
    },
    getMaxWidthOfPlayer(){
      //screenWidth() -> einbauen
      return this.isSmallTouchDevice()?300:640;
    },
    getHeightOfPlayer(){
      return this.isSmallTouchDevice()?200:360;
    }
  },
   beforeRouteEnter: (to,from,next) => {
		next(() => {
       setTimeout(()=>{
				window.scrollTo(0, 0);
			},0);
		});
  },
  created() {
    this.iniProject();
  },
  destroyed() {
    this.project=null;
  },
};
</script>

<style scoped type='text/css'>
.cover{
  max-width: 100%;
  max-height: 400px;
}
</style>